export default __webpack_public_path__ + "static/media/loginEntryPointChat.1f01f233.webp";